import type { Config } from 'tailwindcss';
import colors from 'tailwindcss/colors';

export default {
  content: ['./src/**/*.{js,jsx,ts,tsx}'],
  theme: {
    colors: {
      grey: colors.gray,
    },
    extend: {
      fontFamily: {
        aspekta: ['Aspekta', 'sans-serif'],
      },
      borderRadius: {
        lg: '0.5rem',
        xl: '0.75rem',
        '2xl': '1rem',
        '3xl': '1.5rem',
        tab: '0.625rem',
        nav: '0.875rem',
        card: '1.25rem',
      },
      boxShadow: {
        card: '0px 4px 6px hsla(0, 0%, 0%, 0.02)',
        button: '0px 2px 6px hsla(0, 0%, 0%, 0.06)',
        'pop-up': '0px 4px 10px 0px hsla(0,0%,0%,0.15)',
        dialog: '0px 6px 15px 0px hsla(0,0%,0%,0.2)',
        sidebar: '12px 0 40px rgba(14,28,30,0.35)',
        header: '0px 1px 8px 0 hsla(0,0%,0%,10%)',
      },
      transitionProperty: {
        width: 'width',
      },
      colors: {
        transparent: 'transparent',
        white: '#fff',
        sage: {
          1: '#f4f7f6',
          2: '#eef5f3',
          3: '#e3eae8',
          4: '#dbe7e4',
          5: '#9fb8b3',
          6: '#7c8b88',
          7: '#6f8a85',
          8: '#5f6f6c',
          9: '#2b3a38',
          10: '#0e1c1e',
        },
        mint: {
          1: '#e4f2ef',
          2: '#c6e5df',
        },
        teal: {
          1: '#2a7d6e',
          2: '#1f5f54',
        },
        emerald: {
          1: '#e3f4ea',
          2: '#1e8a5a',
        },
        crimson: {
          1: '#fbe6e4',
          2: '#d0342c',
        },
        // 'site-background': '#fafcff',
        'site-background': '#f8f9fa',
        'dialog-backdrop': '#15181c',
        brand: {
          green: '#d8fa52',
        },
        green: {
          primary: '#dfff5d',
          bg: '#f8fee1',
          text: '#48BB78',
          // 1: '#AED162',
          1: '#a8eb61',
          2: '#50955F',
          3: '#19614D',
        },
        lavender: {
          primary: '#b19cfc',
          bg: '#ece7fe',
        },
        rose: {
          primary: '#ef95b6',
          bg: '#fee7f0',
        },
        blue: {
          primary: '#95efd5',
          bg: '#e7fef7',
          highlight: '#5cdbdb',
          1: '#6bc1f8',
          2: '#10a2fd',
          3: '#357dd2',
          4: '#255fb0',
        },
        cream: {
          primary: '#f4e3d7',
          bg: '#fbf4ef',
        },
        red: {
          1: '#feb3af',
          2: '#f2625a',
          3: '#df2a20',
          4: '#bd180f',
        },
        orange: {
          1: '#ffd1b7',
          2: '#ff9068',
          3: '#ff5900',
          4: '#cc4700',
        },
        grey: {
          1: '#f7f8f8',
          2: '#e4e5e7',
          3: '#cfd1d3',
          // 4: '#8a8f93',
          4: '#a0aec0',
          // 5: '#585c5f',
          5: '#718096',
          6: '#36383a',
          7: '#242628',
          8: '#1b1c1d',
          9: '#0f0f10',
        },
      },
    },
  },
  plugins: [],
} satisfies Config;
